exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#usersModal .v--modal-box.v--modal{min-width:700px!important;min-height:450px!important}#usersModal .modal__content{margin-top:-50px}#usersModal .modal__footer{display:none}#usersModal .v-tabs__bar{margin-bottom:10px}.v-tabs,.v-window,.v-window-item,.v-window__container{height:95%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21ff8a06","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/userManagement/Users.vue
// module id = 1945
// module chunks = 0